import { Typography } from '@mui/material';

type EmptyGridCellProps = {
  label?: string;
};

export const EmptyGridCell = (props: EmptyGridCellProps) => {
  const { label = undefined } = props;
  return <Typography sx={{ color: (thm) => thm.palette.grey[500] }}>{label || <>&mdash;</>}</Typography>;
};
